module.exports = __webpack_public_path__ + "static/revat-team_mobile-a6dc236946e562f17cfa3db76d6eb852.jpg";